import Vue from "vue"
import App from "./App.vue"
import "@/plugins/vuetify"
import "@/plugins/charts"
import router from "@/plugins/router"
import store from "@/plugins/store"
import i18n from "@/plugins/i18n"
import "./config"

Vue.config.productionTip = false
Vue.config.keyCodes.comma = 188

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app")
